import React from "react";
import "./SkeletonCard.scss";

const SkeletonCard: React.FC = () => {
    return (
        <div className="skeleton-card">
            <div className="skeleton-image loading-animation" />
            <div className="skeleton-content">
                <div className="skeleton-line large loading-animation" />
                <div className="skeleton-line medium loading-animation" />
                <div className="skeleton-line small loading-animation" />
            </div>
        </div>
    );
};

export default SkeletonCard;
